import React from 'react';
import PropTypes from 'prop-types';
import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';
import Header, {headerItemsLabels} from '../../../Common/Header/header';
import CreateDeviceAppDialog from './Dialogs/CreateDeviceAppDialog/createDeviceAppDialog.js';
import DeviceAppsViewGrid from './DeviceAppsViewGrid/deviceAppsViewGrid';
import {RfidSettingsMenuItemsIds} from '../../../../enums/navigationMenuItemsIds';
import {dialogsNames} from '../../../../enums/dialogsNames';
import CommonDialogWrapper from '../../../Dialogs/CommonDialogWrapper/commonDialogWrapper';


export default class DeviceAppsView extends React.PureComponent {

  constructor(props) {
    super(props);
    this.labels = createLabelHelper('mat.administration.rfidsettings.deviceapps.view.');
  }

  componentDidMount() {
    this.props.actions.init(false);
    this.props.actions.rfidSettingsPageActions.onSelectedMenuItemChanged(RfidSettingsMenuItemsIds.NAV_ELEMENT_DEVICE_APPS);
  }

  getHeaderItems() {
    let {actions} = this.props;
    let hasRows = this.props.sHasRows;
    let selectedRowsData = this.props.sSelectedRowsData;

    return {
      buttons: [
        {
          id:'create',
          label: headerItemsLabels.CREATE,
          icon: 'pl pl-icon-add',
          action: actions.header.onShowCreateDeviceAppDialog,
          actionData: {
            activeDialog: dialogsNames.CREATE_DEVICE_APP_DIALOG,
          }
        },
        {
          id:'edit',
          label: headerItemsLabels.EDIT,
          icon: 'pl pl-edit-icon',
          disabled: !(hasRows && selectedRowsData.size === 1),
          action: actions.header.onShowCreateDeviceAppDialog,
          actionData: {
            activeDialog: dialogsNames.CREATE_DEVICE_APP_DIALOG,
            itemToEdit : selectedRowsData?.get(0)
          }
        }
      ],
    };
  }

  reloadPage = () => {
    this.props.actions.init(true);
  };

  render() {
    let title = this.labels.get('title');
    let headerItems = this.getHeaderItems();
    return (
      <div className="administration-view">
        <div className="title">{title}</div>

        <Header {...headerItems}/>

        <DeviceAppsViewGrid actions={this.props.actions.deviceAppsViewGridActions} />

        <CommonDialogWrapper dialogComponent={CreateDeviceAppDialog}
                             dialogName={dialogsNames.CREATE_DEVICE_APP_DIALOG}
                             actions={this.props.actions.createDeviceAppDialogActions}
                             reloadParentComponent={this.reloadPage}
        />

      </div>
    );
  }
}

DeviceAppsView.propTypes = {
  sGrid: PropTypes.object,
};

